import React from 'react';
import {View, Platform} from 'react-native';
import Animated from 'react-native-reanimated';
import {useSafeAreaInsets} from 'react-native-safe-area-context';
import {useTheme} from '~contexts/ThemeContext';
import {spacing} from '~constants/design';
import ModernEventSearch from '../ModernEventSearch/ModernEventSearch';

interface ModernHomeHeaderProps {
  scrollAnimatedStyle: any;
  globalInputValue: string;
  setGlobalInputValue: (value: string) => void;
  selectedTimeframe: any;
  selectedEventType: any;
  isMapView: boolean;
  setIsMapView: (value: boolean) => void;
  onTimeframePress?: () => void;
  onEventTypePress?: () => void;
  onFilterPress?: () => void;
  onQuickFilterSelect?: (timeframe: any) => void;
  isForKids?: boolean;
  radius?: number;
  timeframes?: any[];
  eventTypes?: any[];
}

const ModernHomeHeader: React.FC<ModernHomeHeaderProps> = ({
  scrollAnimatedStyle,
  globalInputValue,
  setGlobalInputValue,
  selectedTimeframe,
  selectedEventType,
  isMapView,
  setIsMapView,
  onTimeframePress,
  onEventTypePress,
  onFilterPress,
  onQuickFilterSelect,
  isForKids,
  radius,
  timeframes,
  eventTypes,
}) => {
  const {colors} = useTheme();
  const {top} = useSafeAreaInsets();

  return (
      <ModernEventSearch
        globalInputValue={globalInputValue}
        setGlobalInputValue={setGlobalInputValue}
        onFilterPress={onFilterPress}
        selectedTimeframe={selectedTimeframe}
        selectedEventType={selectedEventType}
        isForKids={isForKids}
        radius={radius}
        timeframes={timeframes}
        eventTypes={eventTypes}
      />
  );
};

export default ModernHomeHeader;
